import {Component} from '@angular/core';

declare const $: any;

@Component({
    selector: 'news-list',
    templateUrl: 'news-list.component.html',
    styleUrls: ['news-list.component.scss']
})

export class NewsListComponent
{
    toggleNews() {
        $('#newContent').slideToggle(200);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/home/news-list/news-list.component.ts